import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../settings/index';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';

const api = new Api('markets');

function* loadDataRequest({ payload }) {
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column,
      order,
      filter = '',
      states = [],
      positions = [],
    } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter, states, positions } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortable_columns, filters } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          records,
          filters,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadDataRequest)]);
}
